import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import ManageUser from '../manage.vue'
export default {
  props: {
    receivedUser: {
      type: Object,
      required: true,
    },
  },

  async created() {
    await this.apiService
      .get(`user/${this.receivedUser.id}`)
      .then((response) => {
        this.currentUser = response.content
      })

    await this.fetchAllUnidades()
  },

  data: () => ({
    currentUser: {},
    dialogKey: false,
    editDialog: false,
    offices: [
      { text: 'Auxiliar', value: 0 },
      { text: 'Coordenador', value: 1 },
      { text: 'Enfermeiro', value: 2 },
      { text: 'Engenheiro', value: 3 },
      { text: 'Estagiário', value: 4 },
      { text: 'Recepcionista', value: 5 },
      { text: 'Supervisor', value: 6 },
      { text: 'Técnico', value: 7 },
      { text: 'Farmacêutico', value: 8 },
      { text: 'Fisioterapeuta', value: 9 },
      { text: 'Administrativo', value: 10 },
      { text: 'Gerente', value: 11 },
      { text: 'Nutricionista', value: 12 },
    ],
    types: [
      { text: 'Supervisor Principal', value: 8 },
      { text: 'Supervisor', value: 2 },
      { text: 'Operador', value: 3 },
      { text: 'Coordenador Op.', value: 4 },
      { text: 'Coordenador Setor Assistencial', value: 5 },
      { text: 'Solicitador', value: 6 },
    ],
    mainTypes: [
      { text: 'Master', value: 0 },
      { text: 'Administrador', value: 1 },
      { text: 'Usuário', value: 2 },
    ],
    status: ['Ativo', 'Inativo'],
    allUnidades: [],
    apiService: new ApiService(),
  }),

  components: {
    ManageUser,
  },

  methods: {
    close() {
      this.$emit('close')
    },
    closeDialog() {
      this.editDialog = false
      this.dialogKey = !this.dialogKey
    },
    editUser(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },
    formatDate(date) {
      return Utils.moment(date)
    },
    mainTypeText(value) {
      const found = this.mainTypes.find((t) => t.value === value)
      return found ? this.$t(found.text) : value
    },
    officeText(value) {
      const found = this.offices.find((t) => t.value === value)
      return found ? this.$t(found.text) : value
    },
    typeText(value) {
      const found = this.types.find((t) => t.value === value)
      return found ? this.$t(found.text) : value
    },
    unidadeNameById(id) {
      const found = this.allUnidades.find((u) => u.id === id)
      return found ? found.name : id
    },
    async fetchAllUnidades() {
      // Collect all unique institution IDs from user institutions
      const ids = (this.currentUser.institutions || [])
        .map(
          (inst) =>
            inst.institutionId ||
            (inst.institution && inst.institution.id) ||
            inst.id
        )
        .filter((v, i, arr) => v && arr.indexOf(v) === i)
      if (!ids.length) return
      try {
        const response = await this.apiService.post(
          'unidade/listByIntitutionIds',
          { ids }
        )
        this.allUnidades = response.content || []
      } catch (e) {
        this.allUnidades = []
      }
    },
  },
}
